import { usePermissions } from '@refinedev/core'
import type { PropsWithChildren } from 'react'
import { NotFoundPage } from '~/pages/notFound'
import type { AdminRole } from '~/providers/authProvider'

/**
 * Platform pages: not-found (not 403) for everyone but the platform roles in
 * `allow` (default: platform admins), so nothing leaks.
 */
export function PlatformOnly({
  allow = ['admin'],
  children,
}: PropsWithChildren<{ allow?: readonly AdminRole[] }>) {
  const { data, isLoading } = usePermissions<AdminRole>({})
  if (isLoading) {
    return null
  }
  return data !== undefined && allow.includes(data) ? (
    children
  ) : (
    <NotFoundPage />
  )
}
